interface iOfficeContent {
  title: string;
  details: string;
}

interface iOfficeInfo {
  main: string;
  sub: string;
  contents: iOfficeContent[];
}

type TOfficeInfo = Record<string, iOfficeInfo>;

const officeInfo: TOfficeInfo = {
  // 원당
  "onedang": {
    main: '비상주사무실 안내',
    sub: '원스톱 비상주 서비스(법무 / 세무 연결)',
    contents: [
      {
        title: '제2종 근린생활시설',
        details: `모든 업종 사업자등록이 가능합니다. \n특수업종은 상담이 필요합니다.`,
      },
      {
        title: '비과밀억제권역',
        details:
          '법인 설립시 등록면허세 중과세 면제\n취득세 중과 배제 (9.4% -> 4.6%)',
      },
      {
        title: '계약 체결 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ],
  },
  // 평택점
  "pyeongtaek": {
    main: '비상주사무실 안내',
    sub: '원스톱 비상주 서비스(법무 / 세무 연결)',
    contents: [
      {
        title: '제2종 근린생활시설',
        details: `모든 업종 사업자등록이 가능합니다. \n특수업종은 상담이 필요합니다.`,
      },
      {
        title: '비과밀억제권역',
        details:
          '법인 설립시 등록면허세 중과세 면제\n취득세 중과 배제 (9.4% -> 4.6%)',
      },
      {
        title: '계약 체결 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ],
  },
  // 영등포 구청점
  "yeongdeungpo": {
    main: '공유 사무실 안내',
    sub: '원스톱 비상주 서비스(법무 / 세무 연결)',
    contents: [
      {
        title: '비상주 사무실',
        details: `관공서 및 공공기관 실사 지원\n우편 등기 대리수령 톡알람`,
      },
      {
        title: '사업장 주소지 제공',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
      {
        title: '상주 사무실(초역세권)',
        details:
          '전석 퍼시스 가구(책상 의자 서랍)\n영등포구청역 도보 5분',
      },
    ],
  },
  // 원주점
  "wonju": {
    main: '비상주사무실 안내',
    sub: '원스톱 비상주 서비스(법무 / 세무 연결)',
    contents: [
      {
        title: '제2종 근린생활시설',
        details: `모든 업종 사업자등록이 가능합니다. \n특수업종은 상담이 필요합니다.`,
      },
      {
        title: '비과밀억제권역',
        details:
          '법인 설립시 등록면허세 중과세 면제\n취득세 중과 배제 (9.4% -> 4.6%)',
      },
      {
        title: '계약 체결 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ]
  },
  // 대구점
  "daegu": {
    main: '비상주사무실 안내',
    sub: '원스톱 비상주 서비스(법무 / 세무 연결)',
    contents: [
      {
        title: '제2종 근린생활시설',
        details: `모든 업종 사업자등록이 가능합니다. \n특수업종은 상담이 필요합니다.`,
      },
      {
        title: '비과밀억제권역',
        details:
          '법인 설립시 등록면허세 중과세 면제\n취득세 중과 배제 (9.4% -> 4.6%)',
      },
      {
        title: '계약 체결 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ]
  },

  // 부개점
  "bugae": {
    main: '프리미엄 서비스 안내',
    sub: '원스톱 비상주 서비스(법무 / 세무 연결)',
    contents: [
      {
        title: '비상주 사무실',
        details: `실사지원 \n우편 등기 대리수령 및 문자알람`,
      },
      {
        title: '역세권',
        details:
          '굴포천역, 삼산체육관역\n도보 7분 거리 위치',
      },
      {
        title: '사업장 주소 등록 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      }
    ]
  },
  // 용암점
  "yongam": {
    main: '비상주사무실 안내',
    sub: '원스톱 비상주 서비스(법무 / 세무 연결)',
    contents: [
      {
        title: '비상주 사무실',
        details: `실사지원 \n우편 등기 대리수령 및 문자알람`,
      },
      {
        title: '세무상담',
        details:
          '부동산 등 친절 세무 상담',
      },
      {
        title: '사업장 주소 등록 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ]
  },
  // 안양점
  "anyang": {
    main: '비상주사무실 안내',
    sub: '원스톱 비상주 서비스(법무 / 세무 연결)',
    contents: [
      {
        title: '비상주 사무실',
        details: `실사지원 \n우편 등기 대리수령 및 문자알람`,
      },
      {
        title: '역세권',
        details:
          '안양역 도보 5분거리',
      },
      {
        title: '사업장 주소 등록 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ]
  },
  // 정왕점
  "jeongwang": {
    main: '비상주사무실 안내',
    sub: '원스톱 비상주 서비스(법무 / 세무 연결)',
    contents: [{
      title: '비상주 사무실',
      details: `실사지원 \n우편 등기 대리수령 및 문자알람`,
    },
    {
      title: '세무상담',
      details:
        '부동산 등 친절 세무 상담',
    },
    {
      title: '사업장 주소 등록 단 10분',
      details:
        '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
    },
    ]
  },
  // 대구 용산점
  "yongsan": {
    main: '비상주사무실 안내',
    sub: '원스톱 비상주 서비스(법무 / 세무 연결)',
    contents: [
      {
        title: '비상주 사무실',
        details: `실사지원 \n우편 등기 대리수령 및 문자알람`,
      },
      {
        title: '비과밀억제권역',
        details:
          '법인 설립시 등록면허세 중과세 면제\n취득세 중과 배제 (9.4% -> 4.6%)',
      },
      {
        title: '계약 체결 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ]
  },
  // 인천 계양점
  "gyeyang": {
    main: '비상주사무실 안내',
    sub: '원스톱 비상주 서비스(법무 / 세무 연결)',
    contents: [
      {
        title: '비상주 사무실',
        details: `실사지원 \n우편 등기 대리수령 및 문자알람`,
      },
      {
        title: '세무상담',
        details:
          '부동산 등 친절 세무 상담',
      },
      {
        title: '계약 체결 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ]
  },
  // 청주 복대점
  "bokdae": {
    main: '비상주 사무실 안내',
    sub: '대면 | 비대면 계약 모두 가능하며 연중무휴 상담이 가능합니다',
    contents: [
      {
        title: '제2종 근린생활시설',
        details: `모든 업종 사업자등록이 가능합니다. \n특수업종은 상담이 필요합니다.`,
      },
      {
        title: '비과밀억제권역',
        details:
          '법인 설립시 등록면허세 중과세 면제\n취득세 중과 배제 (9.4% -> 4.6%)',
      },
      {
        title: '계약 체결 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ]
  },
  // 서울 압구정
  "apgujeong": {
    main: '공유 사무실 안내',
    sub: '대면 | 비대면 계약 모두 가능하며 연중무휴 상담이 가능합니다',
    contents: [
      {
        title: '비상주 사무실',
        details: `실사지원 \n우편 등기 대리수령 및 문자알람`,
      },
      {
        title: '세무상담',
        details:
          '부동산 등 친절 세무 상담',
      },
      {
        title: '계약 체결 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ]
  },
  // 서울 암사점
  "amsa": {
    main: '공유 사무실 안내',
    sub: '대면 | 비대면 계약 모두 가능하며 연중무휴 상담이 가능합니다',
    contents: [
      {
        title: '비상주 사무실',
        details: `실사지원 \n우편 등기 대리수령 및 문자알람`,
      },
      {
        title: '세무상담',
        details:
          '부동산 등 친절 세무 상담',
      },
      {
        title: '계약 체결 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ]
  },
  // 시흥배곧
  "baegot": {
    main: '공유 사무실 안내',
    sub: '대면 | 비대면 계약 모두 가능하며 연중무휴 상담이 가능합니다',
    contents: [
      {
        title: '비상주 사무실',
        details: `실사지원,사업자등록서비스\n우편 등기 대리수령 및 문자알람`,
      },
      {
        title: '세무 및 법무 연계 서비스',
        details:
          '각종 세무, 법무 연계상담',
      },
      {
        title: '계약 체결 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ]
  },
  // 학익
  "hakik": {
    main: '공유 사무실 안내',
    sub: '대면 | 비대면 계약 모두 가능하며 연중무휴 상담이 가능합니다',
    contents: [
      {
        title: '비상주 사무실',
        details: `실사지원,사업자등록서비스\n우편 등기 대리수령 및 문자알람`,
      },
      {
        title: '역세권',
        details:
          '인하대역, 인천법원\n 도보 8분거리 위치',
      },
      {
        title: '계약 체결 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ]
  },
  //서울대점
  "seouluni": {
    main: '공유 사무실 안내',
    sub: '대면 | 비대면 계약 모두 가능하며 연중무휴 상담이 가능합니다',
    contents: [
      {
        title: '비상주 사무실',
        details: `실사지원,사업자등록서비스\n우편 등기 대리수령 및 문자알람`,
      },
      {
        title: '세무 상담 서비스',
        details:
          '사업자등록 즉시 신청 및\n분야별 맞춤 세무상담',
      },
      {
        title: '계약 체결 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ]
  },
  //과천별양
  "byeoryang": {
    main: '공유 사무실 안내',
    sub: '대면 | 비대면 계약 모두 가능하며 연중무휴 상담이 가능합니다',
    contents: [
      {
        title: '비상주 사무실',
        details: `실사지원,사업자등록서비스\n우편 등기 대리수령 및 문자알람`,
      },
      {
        title: '세무 상담 서비스',
        details:
          '사업자등록 즉시 신청 및\n분야별 맞춤 세무상담',
      },
      {
        title: '계약 체결 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ]
  },
  // 인천 작전점
  "jakjeon": {
    main: '비상주사무실 안내',
    sub: '원스톱 비상주 서비스(법무 / 세무 연결)',
    contents: [
      {
        title: '비상주 사무실',
        details: `실사지원 \n우편 등기 대리수령 및 문자알람`,
      },
      {
        title: '세무상담',
        details:
          '부동산 등 친절 세무 상담',
      },
      {
        title: '계약 체결 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ]
  },
  // 서울 방이점
  "bangi": {
    main: '비상주사무실 안내',
    sub: '원스톱 비상주 서비스(법무 / 세무 연결)',
    contents: [
      {
        title: '비상주 사무실',
        details: `실사지원 \n우편 등기 대리수령 및 문자알람`,
      },
      {
        title: '세무상담',
        details:
          '부동산 등 친절 세무 상담',
      },
      {
        title: '계약 체결 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ]
  },
  // 청주 율량점
  "yullyang": {
    main: '비상주사무실 안내',
    sub: '원스톱 비상주 서비스(법무 / 세무 연결)',
    contents: [
      {
        title: '비상주 사무실',
        details: `실사지원 \n우편 등기 대리수령 및 문자알람`,
      },
      {
        title: '세무상담',
        details:
          '부동산 등 친절 세무 상담',
      },
      {
        title: '계약 체결 단 10분',
        details:
          '개인사업자 : 신규등록 | 주소이전\n법인사업자 : 법인설립 | 주소이전',
      },
    ]
  },
};

export default officeInfo;
export type { iOfficeInfo };
